// src/constants/footer.ts

export type FooterItem = {
  key: string;
  label: string;
  href: string;
  external?: boolean;
};

export type FooterGroup = {
  key: string;
  title: string;
  items: FooterItem[];
};

export const FOOTER_GROUPS: FooterGroup[] = [
  {
    key: "product",
    title: "Product",
    items: [
      { key: "shop",       label: "Digital Shop", href: "/" },
      { key: "promos",     label: "Promos",       href: "/promos" },
      { key: "dictionary", label: "Dictionary",   href: "/dictionary" },
    ],
  },

  {
    key: "payments",
    title: "Payments",
    items: [
      { key: "payment-options", label: "Payment Options",    href: "/payments" },
      { key: "pay-ai-agent",    label: "Pay with AI Agent",  href: "/connect" },
      { key: "usdt-tron",       label: "USDT on TRON",       href: "/payments#usdt-tron" },
      { key: "usdc-base",       label: "USDC on Base",       href: "/payments#usdc-base" },
      { key: "usdc-fogo",       label: "USDC on FOGOchain",  href: "/payments#usdc-fogo" },
      { key: "pi",              label: "Pi Network",         href: "/payments#pi-network" },
      { key: "nowpayments",     label: "NOWPayments",        href: "/payments#nowpayments" },
    ],
  },

  {
    key: "trust",
    title: "Trust",
    items: [
      { key: "trust-security", label: "Trust & Security", href: "/trust-security" },
      { key: "agent-checkout", label: "AI Agent Checkout", href: "/trust-security#agent-payments" },
      { key: "analytics",      label: "Platform Stats",   href: "/analytics" },
      { key: "changelog",      label: "Release Notes",    href: "/changelog" },
    ],
  },

  {
    key: "legal",
    title: "Legal",
    items: [
      { key: "terms",      label: "Terms",      href: "/terms" },
      { key: "privacy",    label: "Privacy",    href: "/privacy" },
      { key: "disclaimer", label: "Disclaimer", href: "/disclaimer" },
    ],
  },

  {
    key: "developers",
    title: "Developers",
    items: [
      {
        key:   "partner-sdk",
        label: "Partner SDK",
        href:  "/partner/sdk",
      },
      {
        key:   "for-agents",
        label: "AI Catalog API",   // browse-only, no wallet needed — /ai/* endpoints
        href:  "/for-agents",
      },
      {
        key:   "connect",
        label: "Connect Your AI", // MCP + x402, USDC on Base, actual purchases
        href:  "/connect",
      },
      {
        key:      "openapi",
        label:    "OpenAPI Spec",
        href:     "/openapi.json",
        external: true,
      },
      {
        key:      "blog",
        label:    "Blog",
        href:     "https://blog.reloadpi.com",
        external: true,
      },
    ],
  },
];